import { useEffect } from "react";

export const SITE_URL = "https://www.episcope.ai";
export const DEFAULT_TITLE = "Episcope AI | Computer vision for industry, cities and security";
export const DEFAULT_DESCRIPTION =
  "Episcope AI builds real-time computer vision for industrial, urban and security operations. Turn the cameras you already own into intelligent observers, on NVIDIA Jetson edge devices, in the cloud, or hybrid, with an LLM and agent layer on top.";

function upsertMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets document title, description, canonical and Open Graph tags per route.
 * Google renders JavaScript, so per-route tags set here are picked up on crawl.
 */
export function useSeo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  noindex = false,
} = {}) {
  useEffect(() => {
    const url = SITE_URL + path;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    upsertLink("canonical", url);
  }, [title, description, path, noindex]);
}
